<template>
  <v-app>
    <notifications position="bottom right" animation-type="css" />

    <TabletSidebar v-if="$vuetify.breakpoint.width <= 980"></TabletSidebar>
    <sidebar v-else></sidebar>

    <app-bar></app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import sidebar from "@/components/core/Sidebar";
import AppBar from "@/components/core/AppBar";
import TabletSidebar from "@/components/core/TabletSidebar";

export default {
  components: {
    sidebar: sidebar,
    "app-bar": AppBar,
    TabletSidebar,
  },
};
</script>

<style scoped></style>
